import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import { useGetBlockingDomainCategoriesQuery, useLazyGetBlockingDomainCategoriesQuery } from '../../redux/apis/blockingDomainsManagement/bDCategoriesApiSlice'
import EditCreateBlockingDomainCategory from '../../components/BlockingDomains/EditCreateBlockingDomainCategory'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const BlockingDomainCategory = React.memo(() => {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)
  const { data, isLoading, error, isFetching } =
    useGetBlockingDomainCategoriesQuery({
      expand: ['created_by', 'last_updated_by'].join(','),
      page: pagination.current,
      page_size: pagination.pageSize,
      ...(search ? { search } : {}),
      ...filters
    })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Category Name',
      dataIndex: 'category_name',
      key: 'category_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_blockingdomaincategory') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_blockingdomaincategory') && create && (
        <EditCreateBlockingDomainCategory
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('change_blockingdomaincategory') && edit && (
        <EditCreateBlockingDomainCategory
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}
      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetBlockingDomainCategoriesQuery}
            fileName='blocking-domains-category'
          />

          {can('add_blockingdomaincategory') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Domain Type
            </button>
          )}
        </div>
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default BlockingDomainCategory
